exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-tb-highlight{width:100%}.custom-td-highlight{width:33%}.txt-highlight{text-align:center;color:#9f6a28;font-size:15px}.custom-img-highlight{width:80px!important;height:80px!important}@media (max-width:414px){.custom-img-highlight{width:60px!important;height:60px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e8156576","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserProfile/Highlight.vue
// module id = 1172
// module chunks = 0